import { ReactElement, ReactNode } from 'react'

type ReactElementWithProps = ReactElement & {
  props: { children?: ReactNode }
}

/**
 * Recursive function that returns innerText from react node
 * @param {ReactNode} jsx
 * @returns {string} The react node innerText that have been added together
 */
const hasProps = (jsx: ReactNode): jsx is ReactElementWithProps =>
  Object.prototype.hasOwnProperty.call(jsx, 'props')

export const innerText = (jsx: ReactNode): string => {
  const jsxType = typeof jsx

  if (jsx === null || typeof jsx === 'boolean' || typeof jsx === 'undefined') {
    return ''
  }

  switch (jsxType) {
    case 'number':
    case 'string':
      return jsx.toString()
    case 'object':
      if (!jsx) {
        return ''
      }

      if (Array.isArray(jsx)) {
        return jsx.reduce((acc: string, curr: ReactNode): string => acc + innerText(curr), '')
      }

      if (hasProps(jsx) && Object.prototype.hasOwnProperty.call(jsx.props, 'children')) {
        return innerText(jsx.props.children)
      }
      return ''
    default:
      return ''
  }
}
